import { useLocation } from 'react-router';

import { BASIC_DATA_TABLE_DISPLAY_ROWS, SHARED_DASHBOARD_PATH } from '@/features/dashboard';

import CommoditiesTableTab from './CommoditiesTableTab';
import { hasOtherGroupSymbols, useOtherGroupData } from './useOtherGroupData';

import type { CommoditiesTableSectionType } from '@/features/markets/types';

const CommoditiesTable = ({
  layout,
  sections
}: {
  sections: CommoditiesTableSectionType[] | undefined;
  layout?: { fullWidth?: boolean; height?: number };
}) => {
  const { pathname } = useLocation();
  const isDashboard = pathname.startsWith('/dashboard') || pathname === SHARED_DASHBOARD_PATH;
  const height = layout?.height ?? (isDashboard ? BASIC_DATA_TABLE_DISPLAY_ROWS : undefined);
  const { sections: enrichedSections, isLoading } = useOtherGroupData(sections);
  const disableSelection = hasOtherGroupSymbols(sections);

  return (
    enrichedSections && (
      <CommoditiesTableTab
        disableSelection={disableSelection}
        height={height}
        isLoading={isLoading}
        sections={enrichedSections}
      />
    )
  );
};

export default CommoditiesTable;
